import {TOKENS} from '../../tokens'

export const button = {
  dark: {
    primary: {
      bg: TOKENS.dark.positive_700,
      bgHover: TOKENS.dark.positive_900,
      bgDisabled: TOKENS.dark.positive_200,
      text: TOKENS.dark.custom_text_light,
      textDisabled: TOKENS.dark.contrast_0,
    },
    secondary: {
      bg: TOKENS.dark.contrast_50,
      bgHover: TOKENS.dark.contrast_100,
      bgDisabled: TOKENS.dark.contrast_50,
      text: TOKENS.dark.contrast_700,
      textDisabled: TOKENS.dark.contrast_300,
      border: TOKENS.dark.contrast_300,
      borderDisabled: TOKENS.dark.contrast_200,
      outlineText: TOKENS.dark.contrast_600,
    },
    secondaryInverted: {
      bg: TOKENS.dark.contrast_900,
      bgHover: TOKENS.dark.contrast_975,
      bgDisabled: TOKENS.dark.contrast_600,
      text: TOKENS.dark.contrast_0,
      textDisabled: TOKENS.dark.contrast_300,
    },
    negative: {
      bg: TOKENS.dark.negative_500,
      bgHover: TOKENS.dark.negative_600,
      bgDisabled: TOKENS.dark.negative_700,
      text: TOKENS.dark.white,
      textDisabled: TOKENS.dark.negative_300,
      borderDisabled: TOKENS.dark.negative_200,
      outlineText: TOKENS.dark.negative_400,
    },
    primarySubtle: {
      bg: TOKENS.dark.positive_50,
      bgHover: TOKENS.dark.positive_100,
      bgDisabled: TOKENS.dark.positive_50,
      text: TOKENS.dark.positive_600,
      textDisabled: TOKENS.dark.positive_200,
    },
    negativeSubtle: {
      bg: TOKENS.dark.negative_50,
      bgHover: TOKENS.dark.negative_100,
      bgDisabled: TOKENS.dark.negative_50,
      text: TOKENS.dark.negative_600,
      textDisabled: TOKENS.dark.negative_200,
    },
    custom: {
      bg: TOKENS.dark.custom_accent,
      bgHover: TOKENS.dark.custom_accent_hover,
      bgDisabled: TOKENS.dark.custom_accent_disabled,
      text: TOKENS.dark.custom_text,
      textDisabled: TOKENS.dark.custom_text,
    },
  },
  light: {
    primary: {
      bg: TOKENS.light.primary_500,
      bgHover: TOKENS.light.primary_600,
      bgDisabled: TOKENS.light.primary_200,
      text: TOKENS.light.white,
      textDisabled: TOKENS.light.white,
    },
    secondary: {
      bg: TOKENS.light.contrast_50,
      bgHover: TOKENS.light.contrast_100,
      bgDisabled: TOKENS.light.contrast_50,
      text: TOKENS.light.contrast_700,
      textDisabled: TOKENS.light.contrast_300,
      border: TOKENS.light.contrast_300,
      borderDisabled: TOKENS.light.contrast_200,
      outlineText: TOKENS.light.contrast_600,
    },
    secondaryInverted: {
      bg: TOKENS.light.contrast_900,
      bgHover: TOKENS.light.contrast_975,
      bgDisabled: TOKENS.light.contrast_600,
      text: TOKENS.light.contrast_0,
      textDisabled: TOKENS.light.contrast_300,
    },
    negative: {
      bg: TOKENS.light.negative_500,
      bgHover: TOKENS.light.negative_600,
      bgDisabled: TOKENS.light.negative_700,
      text: TOKENS.light.white,
      textDisabled: TOKENS.light.negative_300,
      borderDisabled: TOKENS.light.negative_200,
      outlineText: TOKENS.light.negative_400,
    },
    primarySubtle: {
      bg: TOKENS.light.primary_50,
      bgHover: TOKENS.light.primary_100,
      bgDisabled: TOKENS.light.primary_50,
      text: TOKENS.light.primary_600,
      textDisabled: TOKENS.light.primary_200,
    },
    negativeSubtle: {
      bg: TOKENS.light.negative_50,
      bgHover: TOKENS.light.negative_100,
      bgDisabled: TOKENS.light.negative_50,
      text: TOKENS.light.negative_600,
      textDisabled: TOKENS.light.negative_200,
    },
    custom: {
      bg: TOKENS.light.custom_accent,
      bgHover: TOKENS.light.custom_accent_hover,
      bgDisabled: TOKENS.light.custom_accent_disabled,
      text: TOKENS.light.custom_text,
      textDisabled: TOKENS.light.custom_text,
    },
  },
} as const
